import React, { useCallback, useEffect } from "react";
import {
  getStatusFromCookie,
  setStatusToCookie
} from "components/PageModals/utils";
import { isApproachGuidesVersion } from "src/utils/approach-guides";
import { useLocation } from "@gatsbyjs/reach-router";

type TimeModalFunctions = {
  isModalOpen: boolean;
  onRequestClose: () => void;
  onFormSubmitted: () => void;
};

function useTimedModal(cookieName: string): TimeModalFunctions {
  const [isModalOpen, setIsModalOpen] = React.useState(false);
  const location = useLocation();

  const onRequestClose = useCallback(() => {
    const currentStatus = getStatusFromCookie(cookieName);
    if (currentStatus !== "submitted") {
      setStatusToCookie("closed", 60 * 60 * 24 * 15 /* 15 days */, cookieName);
    }
    setIsModalOpen(false);
  }, [cookieName]);

  const onFormSubmitted = useCallback(() => {
    setStatusToCookie("submitted", 60 * 60 * 24 * 365 /* 1 year */, cookieName);
  }, [cookieName]);

  const cookie = getStatusFromCookie(cookieName);
  const isClosed = cookie === "closed" || cookie === "submitted";

  useEffect(() => {
    const skipOpen = isApproachGuidesVersion(location.search);
    if (isClosed || skipOpen) return;

    setTimeout(() => {
      setIsModalOpen(true);
    }, 3000);
  }, [setIsModalOpen, isClosed, location.search]);

  return {
    isModalOpen,
    onRequestClose,
    onFormSubmitted
  };
}

export default useTimedModal;
